/* MOXIE MODA — Pricing Configurator JS (fees + sales tax) */
(function(){
  function toNum(v){ var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function clamp(n, lo, hi){ return Math.min(Math.max(n, lo), hi); }

  function init(root){
    if(!root) return;
    var wrap = root.querySelector('.mx-wrap, .moxie-wrap');
    var grid = root.querySelector('#moxie-grid');
    var disc = root.querySelector('#moxie-discount');
    if(!wrap || !grid || !disc) return;

    var currency = (wrap.dataset && wrap.dataset.currency) ? wrap.dataset.currency : '$';
    var divisor  = toNum(wrap.dataset && wrap.dataset.divisor ? wrap.dataset.divisor : 2) || 2;
    var decimals = parseInt(wrap.dataset && wrap.dataset.decimals ? wrap.dataset.decimals : 2, 10);
    if (!isFinite(decimals) || decimals < 0) decimals = 2;

    // existing
    var printAddon  = toNum(wrap.dataset && wrap.dataset.printaddon ? wrap.dataset.printaddon : 5);
    var feePercent  = toNum(wrap.dataset && wrap.dataset.feerate ? wrap.dataset.feerate : 3.5) / 100;
    // ➕ NEW: tax percent (sales tax)
    var taxPercent  = toNum(wrap.dataset && wrap.dataset.taxrate ? wrap.dataset.taxrate : 7) / 100;

    function fmt(v){ return currency + (isFinite(v) ? v : 0).toFixed(decimals); }
    function pct(){ return clamp(toNum(disc.value), 0, 100) / 100; }

    function recalcCard(card){
      var b = toNum(card.getAttribute('data-b'));   // Base cost (B)

      var retailInput = card.querySelector('.moxie-retail');
      var costSumInput = card.querySelector('.moxie-costsum');
      var printToggle = card.querySelector('.moxie-print');

      var kEl = card.querySelector('.moxie-k');
      var lEl = card.querySelector('.moxie-l');
      var mEl = card.querySelector('.moxie-m');
      var nEl = card.querySelector('.moxie-n');

      // existing readouts
      var cEl = card.querySelector('.moxie-c');   // Print add-on
      var fEl = card.querySelector('.moxie-f');   // Fees
      // ➕ NEW readout
      var tEl = card.querySelector('.moxie-tax'); // Sales tax

      // seed retail
      if (retailInput && !retailInput.hasAttribute('data-initialized')) {
        var seed = toNum(card.getAttribute('data-retail'));
        if (!retailInput.value) retailInput.value = seed.toFixed(decimals);
        retailInput.setAttribute('data-initialized','1');
      }

      var retail = toNum(retailInput ? retailInput.value : 0);

      // components
      var c = (printToggle && printToggle.checked) ? printAddon : 0; // Print add-on
      var f = retail * feePercent;                                   // Fees (e.g., 3.5%)
      var t = retail * taxPercent;                                   // ➕ Sales tax (e.g., 7%)

      // Total costs now include tax too
      var costSum = b + c + f + t;

      if (costSumInput) costSumInput.value = costSum.toFixed(decimals);

      // Excel parity downstream
      var k = retail * pct();      // K = E * M1
      var l = retail - k;          // L = E - K
      var m = l - costSum;         // M = L - (B+C+D+F+T)
      var n = m / (divisor || 1);  // N = M / divisor

      if (kEl) kEl.textContent = fmt(k);
      if (lEl) lEl.textContent = fmt(l);
      if (mEl) mEl.textContent = fmt(m);
      if (nEl) nEl.textContent = fmt(n);

      if (cEl) cEl.textContent = fmt(c);
      if (fEl) fEl.textContent = fmt(f);
      if (tEl) tEl.textContent = fmt(t);  // ➕ populate tax
    }

    function recalcAll(){
      var cards = grid.querySelectorAll('.moxie-card, .mx-card');
      cards.forEach(recalcCard);
    }

    var cards = grid.querySelectorAll('.moxie-card, .mx-card');
    cards.forEach(function(card){
      var retailField = card.querySelector('.moxie-retail');
      var printToggle = card.querySelector('.moxie-print');
      if (retailField) retailField.addEventListener('input', function(){ recalcCard(card); });
      if (printToggle) printToggle.addEventListener('change', function(){ recalcCard(card); });
    });
    disc.addEventListener('input', recalcAll);

    recalcAll();
  }

  function bootAll(){
    document.querySelectorAll('.moxie-config, .moxie-configurator').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();

  document.addEventListener('shopify:section:load', function(e){
    var el = e && e.target ? e.target : null;
    if (el) {
      var host = el.querySelector('.moxie-config, .moxie-configurator') || (el.matches && el.matches('.moxie-config, .moxie-configurator') ? el : null);
      if (host) init(host);
    } else {
      bootAll();
    }
  });
})();



